import type {
  VoyagerFacetHeatmap,
  VoyagerHeatmapResponse,
} from './VoyagerSearchService.types';

export const buildHeatmapUrl = (
  searchUrl: string,
  configId: string,
  gridLevel = 2,
): string => {
  const params = new URLSearchParams();
  params.set('voyager.config.id', configId);
  params.set('q', '*:*');
  params.set('rows', '0');
  params.set('facet', 'true');
  params.set('facet.heatmap', 'geohash');
  params.set('facet.heatmap.geom', '["-180 -90" TO "180 90"]');
  params.set('facet.heatmap.gridLevel', gridLevel.toString());
  params.set('wt', 'json');

  return `${searchUrl}?${params.toString()}`;
};

export const getHeatmapFromResponse = (
  data: VoyagerHeatmapResponse,
): VoyagerFacetHeatmap | null =>
  data.facet_counts?.facet_heatmaps?.geohash || null;
